<template>
  <el-dialog
    v-if="dialogVisible"
    class="create-cross-record-dialog common-dialog"
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    :before-close="handleCancel"
    :title="title"
    top="20vh"
  >
    <el-form
      ref="dataForm"
      :model="dataForm"
      :label-position="position"
      :rules="editRule"
      :label-width="`${adaptationVars.formLabelWidth}px`"
    >
      <el-form-item v-if="isUpdate" label="区块链" required>
        <el-form-item prop="from_params.chain_id" style="margin-bottom: 0; flex: 1;">
          <el-select
            v-model="dataForm.from_params.chain_id"
            size="small"
            clearable
            placeholder="请选择源区块链"
            :disabled="isUpdate"
          >
            <el-option
              v-for="(item, i) in options"
              :key="item.ChainId + i"
              :label="item.ChainName"
              :value="item.ChainId"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <span class="divider-char">~</span>
        <el-form-item prop="to_params.chain_id" style="margin-bottom: 0; flex: 1;">
          <el-select
            v-model="dataForm.to_params.chain_id"
            size="small"
            clearable
            placeholder="请选择目标区块链"
            :disabled="isUpdate"
          >
            <el-option
              v-for="(item, i) in options"
              :key="item.ChainId + i"
              :label="item.ChainName"
              :value="item.ChainId"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form-item>

      <el-form-item v-if="!isUpdate" label="选择区块链" required>
        <el-form-item prop="from_params.chain_id" style="margin-bottom: 0; flex: 1;">
          <el-select
            v-model="dataForm.from_params.chain_id"
            size="small"
            clearable
            placeholder="请选择源区块链"
            :disabled="isUpdate"
          >
            <el-option
              v-for="(item, i) in options"
              :key="item.ChainId + i"
              :label="item.ChainName"
              :value="item.ChainId"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <span class="divider-char">~</span>
        <el-form-item prop="to_params.chain_id" style="margin-bottom: 0; flex: 1;">
          <el-select
            v-model="dataForm.to_params.chain_id"
            size="small"
            clearable
            placeholder="请选择目标区块链"
            :disabled="isUpdate"
          >
            <el-option
              v-for="(item, i) in options"
              :key="item.ChainId + i"
              :label="item.ChainName"
              :value="item.ChainId"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form-item>

      <el-form-item label="合约名称" required>
        <el-form-item prop="from_params.contract_name" style="margin-bottom: 0; flex: 1;">
          <el-input v-model="dataForm.from_params.contract_name" placeholder="请输入源合约名称" :disabled="isUpdate"></el-input>
        </el-form-item>
        <span class="divider-char">~</span>
        <el-form-item prop="to_params.contract_name" style="margin-bottom: 0; flex: 1;">
          <el-input v-model="dataForm.to_params.contract_name" placeholder="请输入目标合约名称" :disabled="isUpdate"></el-input>
        </el-form-item>
      </el-form-item>

      <el-form-item label="调用方法" required>
        <el-form-item prop="from_params.execute_method" style="margin-bottom: 0; flex: 1;">
          <el-input v-model="dataForm.from_params.execute_method" placeholder="请输入源调用方法" :disabled="isUpdate"></el-input>
        </el-form-item>
        <span class="divider-char">~</span>
        <el-form-item prop="to_params.execute_method" style="margin-bottom: 0; flex: 1;">
          <el-input v-model="dataForm.to_params.execute_method" placeholder="请输入目标调用方法" :disabled="isUpdate"></el-input>
        </el-form-item>
      </el-form-item>

      <el-form-item label="回滚方法" required>
        <el-form-item prop="from_params.rollback_method" style="margin-bottom: 0; flex: 1;">
          <el-input v-model="dataForm.from_params.rollback_method" placeholder="请输入源回滚方法" :disabled="isUpdate"></el-input>
        </el-form-item>
        <span class="divider-char">~</span>
        <el-form-item prop="to_params.rollback_method" style="margin-bottom: 0; flex: 1;">
          <el-input v-model="dataForm.to_params.rollback_method" placeholder="请输入目标回滚方法" :disabled="isUpdate"></el-input>
        </el-form-item>
      </el-form-item>

      <el-form-item label="调用参数" prop="parameters">
        <operate-param ref="param1" :list="paramListSource" :disable-pre="isUpdate"></operate-param>
        &emsp;
        <operate-param ref="param2" :list="paramListTarget" :disable-pre="isUpdate"></operate-param>
      </el-form-item>

      <el-form-item label="回滚参数" prop="parameters">
        <operate-param
          ref="param3"
          :list="rollbackParamListSource"
          :disable-pre="isUpdate"
        ></operate-param>
        &emsp;
        <operate-param
          ref="param4"
          :list="rollbackParamListTarget"
          :disable-pre="isUpdate"
        ></operate-param>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取消</el-button>
      <el-button
        v-if="!isUpdate"
        type="primary"
        :disabled="disabled"
        @click="handleCreateCrossChainRecord()"
        >确定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import adaptation from '@/mixins/adaptation'
export default {
  name: 'CreateCrossRecordNode',
  mixins: [adaptation],
  adaptationVarsDefine: {
    formLabelWidth: 120
  },
  data() {
    return {
      paramListSource: [{ additionalProp1: '', value: '' }],
      paramListTarget: [{ additionalProp1: '', value: '' }],
      rollbackParamListSource: [{ additionalProp1: '', value: '' }],
      rollbackParamListTarget: [{ additionalProp1: '', value: '' }],
      disabled: false,
      dialogVisible: false,
      disableInput: false,
      title: '新建跨链交易',
      position: 'right',
      isUpdate: false,
      dataForm: {
        crossChainId: null,
        from_params: {
          chain_id: '',
          contract_name: '',
          execute_method: '',
          execute_params: {},
          index: 0
        },
        to_params: {
          chain_id: '',
          contract_name: '',
          execute_method: '',
          execute_params: {},
          rollback_method: '',
          rollback_params: {},
          index: 1
        }
      },
      editRule: {
        // 选择区块链校验
        'from_params.chain_id': [{ required: true, message: '请选择源区块链', trigger: 'change' }],
        'to_params.chain_id': [{ required: true, message: '请选择目标区块链', trigger: 'change' }],
        // 合约名称校验
        'from_params.contract_name': [{ required: true, message: '请输入源合约名称', trigger: 'blur' }],
        'to_params.contract_name': [{ required: true, message: '请输入目标合约名称', trigger: 'blur' }],
        // 调用方法校验
        'from_params.execute_method': [{ required: true, message: '请输入源调用方法', trigger: 'blur' }],
        'to_params.execute_method': [{ required: true, message: '请输入目标调用方法', trigger: 'blur' }],
        // 回滚方法校验
        'from_params.rollback_method': [{ required: true, message: '请输入源回滚方法', trigger: 'blur' }],
        'to_params.rollback_method': [{ required: true, message: '请输入目标回滚方法', trigger: 'blur' }]
      },
      adaptationVars: {
        formLabelWidth: 120
      }
    }
  },
  mounted() {
    this.getOptions()
    // this.getOrgOption()
    // 获取当前选中值s
  },
  methods: {
    //创建跨链交易
    handleCreateCrossChainRecord() {
      const execute_paramsFrom = {}
      const execute_paramsTo = {}

      const rollback_paramsFrom = {}
      const rollback_paramsTo = {}

      this.paramListSource.forEach(item => {
        execute_paramsFrom[item.key] = item.value
      })

      this.paramListTarget.forEach(item => {
        execute_paramsTo[item.key] = item.value
      })

      this.rollbackParamListSource.forEach(item => {
        rollback_paramsFrom[item.key] = item.value
      })

      this.rollbackParamListTarget.forEach(item => {
        rollback_paramsTo[item.key] = item.value
      })

      this.dataForm.from_params.execute_params = execute_paramsFrom
      this.dataForm.to_params.execute_params = execute_paramsTo
      this.dataForm.from_params.rollback_params = rollback_paramsFrom
      this.dataForm.to_params.rollback_params = rollback_paramsTo

      console.log(this.dataForm)

      this.$refs.dataForm.validate(async valid => {
        if (valid) {
          this.disabled = true
          //获取form数据
          this.$apis.crossChain
            .deliver(this.dataForm)
            .then(res => {
              if (res) {
                this.$message.success('跨链交易成功')
                this.$emit('update:list')
                this.handleCancel()
              } else {
                this.$message.error(err)
              }
            })
            .catch(err => {
              // this.$message.error(err)
              this.disabled = false
            })
        } else {
          this.$message.warning('请完善信息')
          this.disabled = false
          return
        }
      })
    },
    //下载
    async startDownload() {
      this.downloadDisabled = true
      this.downloading = true
      let filename = this.deploymentPackage
      //this.downloadFile(filename)
      this.deploymentPackage = '正在下载 ' + this.deploymentPackage
      try {
        await this.downloadFile(filename)
      } catch (err) {
        let msg = '下载 ' + filename + ' 失败： ' + err.message
        this.$message.warning(msg)
        console.log(msg)
      }
      this.downloading = false
      this.downloadDisabled = false
      this.downloadDialogVisible = false
      this.deploymentPackage = ''
      this.handleCancel()
    },
    downloadFile(fileName) {
      let self = this
      return new Promise((resolve, reject) => {
        const baseUrl =
          self.g_Config.BASE_URL +
          '/cbaas-service/v1/crosschain/download?crossChainId=' +
          self.crosschainId
        let xhr = new XMLHttpRequest()
        xhr.open('get', baseUrl, true)
        xhr.responseType = 'blob' // 转换流
        xhr.setRequestHeader(
          'Authorization',
          'Bearer ' + localStorage.getItem('cbaas_system_Token')
        )
        xhr.onload = function() {
          if (xhr.status === 200) {
            let blob = this.response
            let a = document.createElement('a')
            let url = window.URL.createObjectURL(blob)
            a.href = url
            a.download = '跨链包' // 文件名
            a.click()
            window.URL.revokeObjectURL(url)

            resolve(true)
          } else {
            reject('status: ' + xhr.status + '\n response: ' + this.response)
          }
        }
        xhr.send()
      })
    },
    getOptions() {
      let param = {
        offset: 0,
        limit: 50
      }
      this.$apis.home.getSubscribeQueryList(param).then(res => {
        if (res.data && res.data.items) {
          this.options = res.data.items
        }
      })
    },
    handleChainSelect(type) {
      this.getOrgOption(type)
    },

    handleCancel() {
      this.dialogVisible = false
      this.disabled = false
    },
    handleOpen(data) {
      if (data) {
        this.isUpdate = true
        this.title = '执行参数'
        let detailsData1 = JSON.parse(data.chain1_params)
        let detailsData2 = JSON.parse(data.chain2_params)

        // console.log(detailsData1)
        // console.log(detailsData2)

        this.dataForm.from_params = detailsData1
        this.dataForm.to_params = detailsData2

        this.dataForm.from_params.execute_params = this.convertObjectToArray(
          detailsData1.execute_params
        )

        if (this.dataForm.from_params.execute_params.length > 0) {
          this.paramListSource = this.dataForm.from_params.execute_params
        } else {
          this.paramListSource = [{ key: '', value: '' }]
        }

        this.dataForm.from_params.rollback_params = this.convertObjectToArray(
          detailsData1.rollback_params
        )
        if (this.dataForm.from_params.rollback_params.length > 0) {
          this.rollbackParamListSource = this.dataForm.from_params.rollback_params
        } else {
          this.rollbackParamListSource = [{ key: '', value: '' }]
        }

        this.dataForm.to_params.execute_params = this.convertObjectToArray(
          detailsData2.execute_params
        )
        if (this.dataForm.to_params.execute_params.length > 0) {
          this.paramListTarget = this.dataForm.to_params.execute_params
        } else {
          this.paramListTarget = [{ key: '', value: '' }]
        }

        this.dataForm.to_params.rollback_params = this.convertObjectToArray(
          detailsData2.rollback_params
        )
        if (this.dataForm.to_params.rollback_params.length > 0) {
          this.rollbackParamListTarget = this.dataForm.to_params.rollback_params
        } else {
          this.rollbackParamListTarget = [{ key: '', value: '' }]
        }
      } else {
        this.isUpdate = false
        this.title = '新建跨链交易'
        this.paramListSource = [{ key: '', value: '' }]
        this.paramListTarget = [{ key: '', value: '' }]
        this.rollbackParamListSource = [{ key: '', value: '' }]
        this.rollbackParamListTarget = [{ key: '', value: '' }]
        this.dataForm = {
          crossChainId: JSON.parse(this.$route.query.detail).id,
          from_params: {
            chain_id: '',
            contract_name: '',
            execute_method: '',
            rollback_method: '',
            execute_params: {},
            index: 0
          },
          to_params: {
            chain_id: '',
            contract_name: '',
            execute_method: '',
            execute_params: {},
            rollback_method: '',
            rollback_params: {},
            index: 1
          }
        }
      }

      this.dialogVisible = true
    },

    convertObjectToArray(obj) {
      // return Object.keys(obj).map(key => ({ key: key, value: obj[key] }));
      return Object.keys(obj).map(key => {
        return { key: key, value: obj[key] }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.create-cross-record-dialog.common-dialog {
  /deep/ .el-dialog {
    width: var(--common-dialog-large-width);
  }

  .el-form {
    margin-right: var(--common-dialog-form-margin-right);

    .el-select {
      width: 100%;
    }

    .divider-char {
      padding: 0 var(--base-size-4);
    }

    /deep/ .el-form-item__content {
      display: flex;
    }
  }
}
</style>
